import "react-toastify/dist/ReactToastify.css";
import ContactsTable from "@components/Tables/ContactsTable";

import { TitleWithDivider } from "@common/TitleWithDivider";
import WarningModal from "@components/Modals/WarningModal";
import { SearchBar } from "@components/SearchBar/SearchBarTemplate";
import { HeaderItems } from "@common/HeaderItems";
import LoadingIcon from "@common/LoadingIcon";
import FilterModal from "@components/Modals/FilterSelectModal";
import PaginationControls from "@services/PaginationControls";
import messages from "@constants/Messages";
import pageHeaders from "@constants/PageHeaders";
import { useKakelyMainPage } from "@pages/KAKELY/KakelyExternalContactMainPage/hooks/useKakelyMainPage";

const KakelyExternalContactMainPage: React.FC = () => {
  const form = useKakelyMainPage();

  return (
    <>
      <div>
        <TitleWithDivider
          titleText={pageHeaders.KAKELY.mainExternal}
          useDivider={true}
        />
        <SearchBar
          searchBarText={form.searchTerm}
          placeHolderText={"電話帳検索キーワード"}
          buttonLeft={"検索"}
          buttonRight={"絞込検索"}
          setSearchTerm={form.setSearchTerm}
          onSearch={form.onSearch}
          onFilterSearch={form.onFilteredSearch}
          disabled={form.loading}
        ></SearchBar>
        <HeaderItems
          items={form.headerItems}
          topPadding={5}
          disabled={form.loading}
        ></HeaderItems>
        {form.loadingAllUsers && (
          <div className="fixed inset-0 flex items-center justify-center backdrop-brightness-50 z-50">
            <div className="bg-white bg-opacity-95 p-5 rounded-lg shadow-lg flex items-center justify-center">
              <LoadingIcon bodyText={messages.kakely.loading} />
            </div>
          </div>
        )}
        <div className="mb-5"></div>
        {form.loading ? (
          <div className="flex items-center justify-center h-40 rounded-xl">
            <LoadingIcon />
          </div>
        ) : (
          <>
            <ContactsTable
              onUserSelect={form.handleUserSelect}
              onDeselectAll={form.handleDeselectAll}
              userInformation={form.contactData}
              users={form.selectedContacts}
              allSelected={form.allSelected}
              setAllSelected={form.setAllSelected}
              itemsPerPage={form.itemsPerPage}
              setDeselectedUsers={form.setDeselectedUsers}
              deselectedUsers={form.deselectedUsers}
            />
            <PaginationControls
              currentPage={form.currentPage}
              totalPages={form.totalPages}
              onPageChange={form.handlePageChange}
              perPage={form.itemsPerPage}
              displayedItem={"社外電話帳"}
              totalItems={form.totalUsers}
              setPerPage={form.setItemsPerPage}
            ></PaginationControls>
          </>
        )}
        <WarningModal
          title={form.deleteModalTitle}
          body={form.deleteModalBody}
          confirmText={form.deleteModalConfirm}
          isOpen={form.deleteModalOpen}
          onConfirm={form.handleDeleteModalConfirm}
          onRequestClose={form.handleDeleteModalClose}
        ></WarningModal>
        <FilterModal
          isOpen={form.filterModalOpen}
          onRequestClose={form.onFilteredModalClose}
          onApplyFilters={form.doFilteredSearch}
          filters={form.filters}
        ></FilterModal>
      </div>
    </>
  );
};

export default KakelyExternalContactMainPage;
